/**
 * Web Mercator resolution at zoom level z, adjusted for latitude
 */
function isFiniteNumber(n) {
  return typeof n === "number" && Number.isFinite(n);
}

const DEFAULT_LAT = 32.0853;

export function wmResolution(z, lat) {
  if (!isFiniteNumber(z) || !isFiniteNumber(lat)) return wmResolution(12, DEFAULT_LAT);
  const latRad = (lat * Math.PI) / 180;
  const cos = Math.cos(latRad);
  if (!Number.isFinite(cos) || cos <= 0) return wmResolution(12, DEFAULT_LAT);
  return (156543.03392804097 * cos) / Math.pow(2, Math.max(0, Math.min(19, z)));
}

/**
 * Calculate Web Mercator zoom for a given resolution (fractional), adjusted for latitude
 */
export function wmZoomForResolution(res, lat) {
  if (!isFiniteNumber(res) || res <= 0 || !isFiniteNumber(lat)) return 12;
  const latRad = (lat * Math.PI) / 180;
  const cos = Math.cos(latRad);
  if (!Number.isFinite(cos) || cos <= 0) return 12;
  const z = Math.log2((156543.03392804097 * cos) / res);
  return Math.max(0, Math.min(19, z));
}
